import { render } from "./MemoireApprenantPage.vue?vue&type=template&id=57bb672d"
import script from "./MemoireApprenantPage.vue?vue&type=script&lang=js"
export * from "./MemoireApprenantPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__